<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 25px;
  padding: 23px;
  line-height: 40px;
  /*width: 230px;*/
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}

@keyframes loginBG {
	0%,to {
		background-position-x: 0
	}

	50% {
		background-position-x: 100%
	}
}

@keyframes fadeInUp {
	0% {
		opacity: 0;
		transform: translateY(15px)
	}

	to {
		opacity: 1;
		transform: translateY(0)
	}
}
.dong_box{
	height: 100%;
}
.dong_box .dong_i{
	width: auto;
	animation: loginBG 40s linear infinite;
	background: url(/img/loginbg.png) no-repeat 0 0;
	background-size: auto 100%;
	height: 100%;
}
	
.popupbox{
	padding: 15px;
	color: #000;
	height: 81%;
	background-color: #fff;
}
.popupbox .title {
	padding: 8px 10px 20px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	font-size: 28px;
}

.popupbox .content {
    padding-bottom: 1.333vw;
    height: 100%;
    overflow-y: auto;
    width: 100%;
    padding-top: 2.667vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.contentitem{
	margin: 10px 0;
	padding:20px;
	width: 100%;
	border-bottom: 1px solid #ebedf0;
	text-align: center;
}
.popupbox .content .choose {
	width: 95px;
	height: 95px;
	border: 6px solid #8e44ad;
}
.p-10{
	padding: 10px;
}
.p-l-10{
	padding-left: 10px;
}
.p-r-10{
	padding-right: 10px;
}
.p-t-10{
	padding-top: 10px;
}
.p-b-10{
	padding-bottom: 10px;
}
.p-lr-10{
	padding-left: 10px;
	padding-right: 10px;
}
.p-tb-10{
	padding-top: 10px;
	padding-bottom: 10px;
}

.da {
	background: #8948fb;
}

.xiao {
	background: #ff6398;
}

.dan {
	background: #2196f3;
}

.shuang {
	background: #ff7d73;
}

.bg_da{
	background: #8948fb;
	color: #fff;
	font-size: 16px;
	border-radius: 10px;
	padding: 2px 5px;
}
.bg_xiao{
	background: #ff6398;
	color: #fff;
	font-size: 16px;
	border-radius: 10px;
	padding: 2px 5px;
}
.bg_dan{
	background: #2196f3;
	color: #fff;
	font-size: 16px;
	border-radius: 10px;
	padding: 2px 5px;
}
.bg_shuang{
	background: #ff7d73;
	color: #fff;
	font-size: 16px;
	border-radius: 10px;
	padding: 2px 5px;
	
}
.opennum{
	font-size: 28px;
	    color: red;
	    font-weight: bold;
	    padding: 0 5px;
}
</style>
